import { render } from "./motors-add.vue?vue&type=template&id=f97c8b80"
import script from "./motors-add.vue?vue&type=script&lang=js"
export * from "./motors-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__